// extracted by mini-css-extract-plugin
module.exports = {"timer":"Spinner_timer__kBB8i","timerAnmiation":"Spinner_timerAnmiation__1TwC5","isCenter":"Spinner_isCenter__1oiBn"};